import { render } from "./App.vue?vue&type=template&id=cf93e610"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=cf93e610&lang=css"

import exportComponent from "/Users/salome/Desktop/salomeg5/bedoya_group/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__